import { useRef } from 'react';
import useFullScreenEditor from '/src/features/editor/hook/useFullScreenEditor';
import './ButtonFullScreen.css';

// Component for toggling full screen throught a button, can also be triggered thanks to F11
function ButtonFullScreen() {
    const toggleButtonFullScreen = useRef(null);
    const { toggleFullScreen } = useFullScreenEditor(toggleButtonFullScreen);

    return <div ref={toggleButtonFullScreen} className="fullscreen" onClick={toggleFullScreen}></div>
}

export default ButtonFullScreen